import { render, staticRenderFns } from "./AdminStudentReports.vue?vue&type=template&id=42f449be&scoped=true&"
import script from "./AdminStudentReports.vue?vue&type=script&lang=js&"
export * from "./AdminStudentReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminStudentReports.vue?vue&type=style&index=0&id=42f449be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f449be",
  null
  
)

export default component.exports